/* eslint-disable no-unused-vars */

class Modal {
  constructor(
    elements = {},
    contentProvider = null,
    settings = {
      display_before_content_load: false,
    },
  ) {
    this.contentProvider = contentProvider;
    this._elements = elements;
    this.masterModal = null;
    this.currentModal = this;
    this.settings = settings;
    this.eventHandlers = {
      close_button_click: eventObj => {
        eventObj.preventDefault();
        eventObj.stopPropagation();
        this.close();
      },
      modal_content_click: eventObj => {
        eventObj.stopPropagation();
      },
      background_click: eventObj => {
        eventObj.stopPropagation();
        this.close();
      },
      esc_keypress: eventObj => {
        if (eventObj.keyCode === 27) {
          eventObj.preventDefault();
          this.close();
        }
      },
    };
  }

  get _defaultElements() {
    return {
      modal_window: document.querySelector('.js-modal-window'),
      modal_content: document.querySelector('.js-modal-content'),
      close_button: document.querySelector('.js-modal-close-button'),
    };
  }

  get elements() {
    return Object.assign({}, this._defaultElements, this._elements);
  }

  showModal() {}

  setModalStyle() {}

  hideModal() {}

  unsetModalStyle() {}

  initModalControls() {
    this.initClose();
  }

  initClose() {
    this.elements.close_button.addEventListener(
      'click',
      this.eventHandlers['close_button_click'],
    );
    this.elements.modal_content.addEventListener(
      'click',
      this.eventHandlers['modal_content_click'],
    );
    document.body.addEventListener(
      'click',
      this.eventHandlers['background_click'],
    );
    window.addEventListener('keyup', this.eventHandlers['esc_keypress']);
  }

  clearContent() {
    this.elements.modal_content.innerHTML = '';
  }

  setContent(html) {
    this.elements.modal_content.innerHTML = html;
  }

  uninit() {
    this.masterModal.uninitClose();
    this.currentModal.uninitContent();
  }

  uninitClose() {
    this.elements.close_button.removeEventListener(
      'click',
      this.eventHandlers['close_button_click'],
    );
    this.elements.modal_content.removeEventListener(
      'click',
      this.eventHandlers['modal_content_click'],
    );
    document.body.removeEventListener(
      'click',
      this.eventHandlers['background_click'],
    );
    window.removeEventListener('keyup', this.eventHandlers['esc_keypress']);
  }

  open() {
    this.masterModal = this;
    if (this.settings.display_before_content_load) {
      this.setModalStyle();
      this.showModal();
    }
    if (this.contentProvider !== null) {
      this.contentProvider
        .getContent()
        .then(response => {
          this.elements.modal_content.innerHTML = response.html;
          if (!this.settings.display_before_content_load) {
            this.setModalStyle();
            this.showModal();
          }
          this.initModalControls();
          this.initContent(response.data);
        })
        .catch(error => {
          this.elements.modal_content.innerHTML = error;
          if (!this.settings.display_before_content_load) {
            this.setModalStyle();
            this.showModal();
          }
          this.initModalControls();
        });
    } else {
      if (!this.settings.display_before_content_load) {
        this.setModalStyle();
        this.showModal();
      }
      this.initModalControls();
      this.initContent();
    }
  }

  close() {
    this.uninit();
    this.currentModal.hideModal();
    this.currentModal.unsetModalStyle();
  }

  swapModal(modalObject) {
    this.currentModal.uninitContent();
    this.currentModal.clearContent();
    modalObject.contentProvider
      .getContent()
      .then(response => {
        this.currentModal.unsetModalStyle();
        this.currentModal.setContent(response.html);
        modalObject.setModalStyle();
        modalObject.initContent(response.data);
        modalObject.masterModal = this.masterModal;
        this.currentModal = modalObject;
      })
      .catch(error => {
        this.currentModal.setContent(error);
        modalObject.masterModal = this.masterModal;
        this.currentModal = modalObject;
      });
  }

  initContent(data) {}

  uninitContent() {}
}

export default Modal;



// WEBPACK FOOTER //
// ./src/js/lib/modals/Modal.js